export default __webpack_public_path__ + "static/media/office-training-tab1bg.3830e708.png";